import { Menu, UnstyledButton } from '@mantine/core';
import { FC, useCallback } from 'react';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

type Props = {
  onEdit?: () => void;
  onRemove?: () => void;
  onView?: () => void;
  onRestart?: () => void;
};

export const ActionMenu: FC<Props> = ({
  onEdit,
  onRemove,
  onView,
  onRestart,
}) => {
  const handleViewClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onView?.();
    },
    [onView]
  );

  const handleRemoveClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onRemove?.();
    },
    [onRemove]
  );

  const handleRestartClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onRestart?.();
    },
    [onRestart]
  );

  const handleEditClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onEdit?.();
    },
    [onEdit]
  );

  return (
    <Menu position="bottom-end" offset={-10}>
      <Menu.Target>
        <UnstyledButton
          className={styles.button}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon className={styles.icon} name="more" />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown className={styles.dropdown}>
        {onView && (
          <Menu.Item
            className={styles.dropdownItem}
            onClick={handleViewClick}
            leftSection={
              <Icon className={styles.dropdownIcon} name="visibility" />
            }
          >
            View
          </Menu.Item>
        )}
        {onEdit && (
          <Menu.Item
            className={styles.dropdownItem}
            onClick={handleEditClick}
            leftSection={<Icon className={styles.dropdownIcon} name="edit" />}
          >
            Edit
          </Menu.Item>
        )}
        {onRemove && (
          <Menu.Item
            className={styles.dropdownItem}
            onClick={handleRemoveClick}
            leftSection={
              <Icon className={styles.dropdownIcon} name="deleteTemporary" />
            }
          >
            Remove
          </Menu.Item>
        )}
        {onRestart && (
          <Menu.Item
            className={styles.dropdownItem}
            onClick={handleRestartClick}
            leftSection={<Icon className={styles.dropdownIcon} name="reboot" />}
          >
            Restart
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
